import { PersistentStorageService } from '@packages/shared/core/common/services';
import { Logger } from '@packages/shared/core/common/logger/interfaces';
import { PreferredTheme } from '@packages/shared/core/theme/entities';
import { ThemeService } from '@packages/shared/core/theme/services';

export class ThemeClientService implements ThemeService {
  private persistentStorage: PersistentStorageService;
  private logger: Logger;

  constructor(persistentStorage: PersistentStorageService, logger: Logger) {
    this.persistentStorage = persistentStorage;
    this.logger = logger;
  }

  getInitialTheme() {
    return document.body.dataset.theme as PreferredTheme;
  }

  async setTheme(theme: PreferredTheme) {
    await this.persistentStorage.set('theme', theme);
    document.body.dataset.theme = theme;
  }
}
